import React from "react";
import Location from "../components/Location";

// update log
// FB 4371 DK    03/29/2021    Added to invoke the location component

export default function FacilityPage(data:any) {
  return <Location {...data}/>;
}
